/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface BCMBookingIdRemarkRuleFormData
 */
export interface BCMBookingIdRemarkRuleFormData {
    /**
     * 
     * @type {string}
     * @memberof BCMBookingIdRemarkRuleFormData
     */
    id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BCMBookingIdRemarkRuleFormData
     */
    disabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BCMBookingIdRemarkRuleFormData
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BCMBookingIdRemarkRuleFormData
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BCMBookingIdRemarkRuleFormData
     */
    comment?: string | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof BCMBookingIdRemarkRuleFormData
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {string}
     * @memberof BCMBookingIdRemarkRuleFormData
     */
    bookingIdRemark?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BCMBookingIdRemarkRuleFormData
     */
    providers?: Array<string> | null;
}

export function BCMBookingIdRemarkRuleFormDataFromJSON(json: any): BCMBookingIdRemarkRuleFormData {
    return BCMBookingIdRemarkRuleFormDataFromJSONTyped(json, false);
}

export function BCMBookingIdRemarkRuleFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BCMBookingIdRemarkRuleFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'bookingIdRemark': !exists(json, 'bookingIdRemark') ? undefined : json['bookingIdRemark'],
        'providers': !exists(json, 'providers') ? undefined : json['providers'],
    };
}

export function BCMBookingIdRemarkRuleFormDataToJSON(value?: BCMBookingIdRemarkRuleFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
        'allowEdit': value.allowEdit,
        'description': value.description,
        'comment': value.comment,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'bookingIdRemark': value.bookingIdRemark,
        'providers': value.providers,
    };
}


